<wv-background-stripe color="plain-yellow">
  <div class="wv-center-container content">
    <h1 class="quote">“{{quote.text}}”</h1>
    <div class="auteur">{{quote.auteur}}</div>
  </div>
</wv-background-stripe>
